import React, { useEffect, useState, useRef } from "react";
import useMainContentDimensions from "../../../../utils/mainContentDimensions";

import {
  Card,
  CardContent,
  Grid,
  Box,
  CardHeader,
  Tabs,
  Tab,
  Badge,
  Typography,
  IconButton,
  Button,
  Tooltip,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { DataGrid } from "@mui/x-data-grid";
import { PictureAsPdf } from "@mui/icons-material";
import Excel from "../../../../vendor/icons/icon-excel.svg";
import Csv from "../../../../vendor/icons/csv-file.png";
import { Link } from "react-router-dom";
import useWindowDimensions from "../../../../utils/windowDimensions";
import useAuth from "../../../../hooks/useAuth";
import useUser from "../../../../hooks/useUser";
import EditDelete from "../../../../components/EditDelete";
import RenewUser from "../../../users/userlist/components/RenewUser";
import { useDialog } from "../../../../contexts/DialogContext";
import { getTimeStamp, a11yProps, formatDate, addDays } from "../../../../utils/common";
import TabPanel from "../../../../components/TabPanel";
import Today from "./today";
import Yesterday from "./yesterday";
import Tomorrow from "./tomorrow";
import Next from "./next";
import Expiring from "./expiring";

import useMediaQuery from "@mui/material/useMediaQuery";
import ToolBar from "../../../../components/Toolbar";

function UserExpiring() {
  const { user } = useAuth();
  const initialFetchDone = useRef(false);
  // Date
  const today = new Date();

  const dayAfterYesterday = new Date(today);
  dayAfterYesterday.setDate(today.getDate() + 2);

  const formattedDate = dayAfterYesterday.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  const { getAllUser, paging } = useUser();
  const { unSetDialog, openDialog } = useDialog();
  const { totalNumberOfRecords, hasNextPage, pageNumber, pageSize } = paging || {};
  const { isLoadingDownload, downloadFileType, downloadExpiringFile } = useUser();

  const commonFilters = [];

  const [expiringTodays, setExpiringTodays] = useState([]);
  const [expiringYesterdays, setExpiringYesterdays] = useState([]);
  const [expiringTomorrow, setExpiringTomorrow] = useState([]);
  const [expiringNextTwoDays, setExpiringNextTwoDays] = useState([]);

  const [expiringTodayPaging, setExpiringTodayPaging] = useState({
    totalNumberOfRecords: 0,
    hasNextPage: false,
    pageNumber: 0,
    pageSize: 0,
  });

  const [expiringYesterdayPaging, setExpiringYesterdayPaging] = useState({
    totalNumberOfRecords: 0,
    hasNextPage: false,
    pageNumber: 0,
    pageSize: 0,
  });

  const [expiringTomorrowPaging, setExpiringTomorrowPaging] = useState({
    totalNumberOfRecords: 0,
    hasNextPage: false,
    pageNumber: 0,
    pageSize: 0,
  });
  const [expiringNextTwoDayPaging, setExpiringNextTwoDayPaging] = useState({
    totalNumberOfRecords: 0,
    hasNextPage: false,
    pageNumber: 0,
    pageSize: 0,
  });
  const [todayCount, setTodayCount] = useState(0);
  const [yesterdayCount, setYesterdayCount] = useState(0);
  const [tomorrowCount, setTomorrowCount] = useState(0);
  const [next2DaysCount, setnext2DaysCount] = useState(0);

  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 5,
  });

  const [tabValue, setTabValue] = React.useState(1);
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    if (newValue == 0) {
      setExpiringYesterdayPayload(currentExpiringYesterdayPayload);
    } else if (newValue == 1) {
      setExpiringTodayPayload(currentExpiringTodayPayload);
    } else if (newValue == 2) {
      setExpiringTomorrowPayload(currentExpiringTomorrowPayload);
    } else if (newValue == 3) {
      setExpiringNextTwoDayPayload(currentExpiringNextTwoDayPayload);
    }
  };

  const isTablet = useMediaQuery("(max-width:1024px)");
  const isLaptop = useMediaQuery("(min-width:1025px) and (max-width:1440px)");

  const currentExpiringNextTwoDayPayload = {
    filters: [
      ...commonFilters,
      {
        fieldName: "expiration",
        fieldValue:
          formatDate(new Date()) + " 00:00:00," + formatDate(addDays(new Date(), 15)) + " 23:59:59",
        op: "btn",
        dataType: "string",
        condition: "and",
        isJoin: false,
      },
    ],
    pagination: {
      pageNumber: 1,
      pageSize: 5,
    },
    sortFields: [
      {
        field: "createdAt",
        sort: "DESC",
      },
    ],
  };

  const currentExpiringTodayPayload = {
    filters: [
      ...commonFilters,
      {
        fieldName: "expiration",
        fieldValue: formatDate(new Date()) + " 00:00:00," + formatDate(new Date()) + " 23:59:59",
        op: "btn",
        dataType: "string",
        condition: "and",
        isJoin: false,
      },
    ],
    pagination: {
      pageNumber: 1,
      pageSize: 5,
    },
    sortFields: [
      {
        field: "createdAt",
        sort: "DESC",
      },
    ],
  };

  const currentExpiringTomorrowPayload = {
    filters: [
      ...commonFilters,
      {
        fieldName: "expiration",
        fieldValue:
          formatDate(addDays(new Date(), 1)) +
          " 00:00:00," +
          formatDate(addDays(new Date(), 1)) +
          " 23:59:59",
        op: "btn",
        dataType: "string",
        condition: "and",
        isJoin: false,
      },
    ],
    pagination: {
      pageNumber: 1,
      pageSize: 5,
    },
    sortFields: [
      {
        field: "createdAt",
        sort: "DESC",
      },
    ],
  };

  const currentExpiringYesterdayPayload = {
    filters: [
      ...commonFilters,
      {
        fieldName: "expiration",
        fieldValue:
          formatDate(addDays(new Date(), -1)) +
          " 00:00:00," +
          formatDate(addDays(new Date(), -1)) +
          " 23:59:59",
        op: "btn",
        dataType: "string",
        condition: "and",
        isJoin: false,
      },
    ],
    pagination: {
      pageNumber: 1,
      pageSize: 5,
    },
    sortFields: [
      {
        field: "createdAt",
        sort: "DESC",
      },
    ],
  };

  const renewClick = (id) => {
    return openDialog(
      "renew_user",
      "Renew User",
      <RenewUser key={getTimeStamp()} userId={id} />,
      "md",
    );
  };

  const [sortModel, setSortModel] = useState([
    {
      field: "updatedAt",
      sort: "desc",
    },
  ]);
  const { height } = useWindowDimensions();

  const [expiringNextTwoDayPayload, setExpiringNextTwoDayPayload] = useState(
    currentExpiringNextTwoDayPayload,
  );
  const [expiringTodayPayload, setExpiringTodayPayload] = useState(currentExpiringTodayPayload);
  const [expiringTomorrowPayload, setExpiringTomorrowPayload] = useState(
    currentExpiringTomorrowPayload,
  );
  const [expiringYesterdayPayload, setExpiringYesterdayPayload] = useState(
    currentExpiringYesterdayPayload,
  );

  useEffect(() => {
    const fetchAllData = async () => {
      const filters = [];
      // if (user && user.businessType !== "SUPER_ADMIN" && user.tenantId) {
      //   filters.push({
      //     fieldName: "tenantId",
      //     fieldValue: user.tenantId,
      //     op: "eq",
      //     dataType: "long",
      //     condition: "and",
      //     isJoin: false,
      //   });
      // }

      const todayStr = formatDate(new Date());
      const yesterdayStr = formatDate(addDays(new Date(), -1));
      const tomorrowStr = formatDate(addDays(new Date(), 1));
      const next15DaysStr = formatDate(addDays(new Date(), 15));

      const getPayload = (start, end) => ({
        filters: [
          ...filters,
          {
            fieldName: "expiration",
            fieldValue: `${start} 00:00:00,${end} 23:59:59`,
            op: "btn",
            dataType: "string",
            condition: "and",
            isJoin: false,
          },
        ],
        pagination: { pageNumber: 1, pageSize: 5 },
        sortFields: [{ field: "createdAt", sort: "DESC" }],
      });

      const [yesterday, today, tomorrow, next15] = await Promise.all([
        getAllUser(getPayload(yesterdayStr, yesterdayStr)),
        getAllUser(getPayload(todayStr, todayStr)),
        getAllUser(getPayload(tomorrowStr, tomorrowStr)),
        getAllUser(getPayload(todayStr, next15DaysStr)),
      ]);

      setExpiringYesterdays(yesterday?.data || []);
      setYesterdayCount(yesterday?.paging?.totalNumberOfRecords || 0);
      setExpiringYesterdayPaging(yesterday?.paging);

      setExpiringTodays(today?.data || []);
      setTodayCount(today?.paging?.totalNumberOfRecords || 0);
      setExpiringTodayPaging(today?.paging);

      setExpiringTomorrow(tomorrow?.data || []);
      setTomorrowCount(tomorrow?.paging?.totalNumberOfRecords || 0);
      setExpiringTomorrowPaging(tomorrow?.paging);

      setExpiringNextTwoDays(next15?.data || []);
      setnext2DaysCount(next15?.paging?.totalNumberOfRecords || 0);
      setExpiringNextTwoDayPaging(next15?.paging);
      initialFetchDone.current = true;
    };

    if (user) {
      fetchAllData();
    }
  }, [user]);

  const fetchExpiringTodayData = async () => {
    if (Object.keys(expiringTodayPayload).length != 0) {
      const expiringTodayData = await getAllUser(expiringTodayPayload);
      setExpiringTodays(expiringTodayData?.data);
      setTodayCount(expiringTodayData?.paging?.totalNumberOfRecords || 0);
      setExpiringTodayPaging(expiringTodayData?.paging);
    }
  };

  const fetchExpiringTomorrowData = async () => {
    if (Object.keys(expiringTomorrowPayload).length != 0) {
      const expiringTomorrowData = await getAllUser(expiringTomorrowPayload);
      setExpiringTomorrow(expiringTomorrowData?.data);
      setTomorrowCount(expiringTomorrowData?.paging?.totalNumberOfRecords || 0);
      setExpiringTomorrowPaging(expiringTomorrowData?.paging);
    }
  };

  const fetchExpiringYesterdayData = async () => {
    if (Object.keys(expiringYesterdayPayload).length != 0) {
      const expiringYesterdayData = await getAllUser(expiringYesterdayPayload);
      setExpiringYesterdays(expiringYesterdayData?.data);
      setYesterdayCount(expiringYesterdayData?.paging?.totalNumberOfRecords || 0);
      setExpiringYesterdayPaging(expiringYesterdayData?.paging);
    }
  };

  const fetchExpiringNextTwoDaysData = async () => {
    if (Object.keys(expiringNextTwoDayPayload).length != 0) {
      const expiringNextTwoDaysData = await getAllUser(expiringNextTwoDayPayload);
      setExpiringNextTwoDays(expiringNextTwoDaysData?.data);
      setnext2DaysCount(expiringNextTwoDaysData?.paging?.totalNumberOfRecords || 0);
      setExpiringNextTwoDayPaging(expiringNextTwoDaysData?.paging);
    }
  };

  const exportFile = async (fileType) => {
    if (tabValue === 0) {
      await downloadExpiringFile(fileType, expiringYesterdayPayload);
    } else if (tabValue === 1) {
      await downloadExpiringFile(fileType, expiringTodayPayload);
    } else if (tabValue === 2) {
      await downloadExpiringFile(fileType, expiringTomorrowPayload);
    } else if (tabValue === 3) {
      await downloadExpiringFile(fileType, expiringNextTwoDayPayload);
    }
  };

  const onPageChange = (newPaginationModel) => {
    console.log(newPaginationModel, "pagepage");
    const pagination = {
      pageNumber: newPaginationModel.page == 0 ? 1 : newPaginationModel.page + 1,
      pageSize: payload.pagination.pageSize,
    };
    setPayload((prev) => ({ ...prev, pagination }));
    setPaginationModel(newPaginationModel);
  };

  useEffect(() => {
    if (!initialFetchDone.current) return;
    fetchExpiringTodayData();
  }, [expiringTodayPayload]);

  useEffect(() => {
    if (!initialFetchDone.current) return;
    fetchExpiringTomorrowData();
  }, [expiringTomorrowPayload]);

  useEffect(() => {
    if (!initialFetchDone.current) return;
    fetchExpiringYesterdayData();
  }, [expiringYesterdayPayload]);

  useEffect(() => {
    if (!initialFetchDone.current) return;
    fetchExpiringNextTwoDaysData();
  }, [expiringNextTwoDayPayload]);

  const handleSortModelChange = (newModel) => {
    console.log(newModel, "newModel");
    if (newModel.length !== 0) {
      setSortModel(newModel);
      setPayload((prev) => ({ ...prev, sortFields: newModel }));
    }
  };

  const columns = [
    {
      field: "action",
      headerName: "Action",
      filter: false,
      sortable: false,
      renderCell: (params) => {
        const onClick = (e) => {
          e.stopPropagation(); // don't select this row after clicking
          const api = params.api;
          const thisRow = {};
          api
            .getAllColumns()
            .filter((c) => c.field !== "__check__" && !!c)
            .forEach((c) => (thisRow[c.field] = params.getValue(params.id, c.field)));
          console.log(thisRow, "thisRow");
        };
        return (
          <EditDelete
            rowClick={onClick}
            renewClick={() => renewClick(params.id)}
            menus={["renew"]}
          />
        );
      },
    },
    {
      field: "userName",
      headerName: "User Name",
      renderCell: (params) => <Link to={"/user/details?id=" + params.id}>{params.value}</Link>,
      width: 150,
    },
    {
      field: "fullName",
      headerName: "Customer Name",
      width: 150,
    },
    {
      field: "expiration",
      headerName: "Expiry Date",
      width: 180,
    },
    {
      field: "mobileNo",
      headerName: "Mobile",
      width: 100,
    },
    {
      field: "tenantName",
      headerName: "Franchise Name",
      width: 200,
    },
    {
      field: "planName",
      headerName: "Plan",
      width: 200,
    },
  ];

  const paginationMetaRef = useRef();

  // Memoize to avoid flickering when the `hasNextPage` is `undefined` during refetch
  const paginationMeta = React.useMemo(() => {
    if (hasNextPage !== undefined && paginationMetaRef.current?.hasNextPage !== hasNextPage) {
      paginationMetaRef.current = { hasNextPage };
    }
    return paginationMetaRef.current;
  }, [hasNextPage]);

  return (
    <Grid item xs={12} md={6}>
      <Card
        sx={{
          width: "100%",
          borderRadius: "20px",
          backgroundColor: "#ffffff",
          boxShadow: "0 10px 40px -10px rgba(0, 0, 0, 0.1)",
          overflow: "hidden",
          border: "none",
        }}
      >
        <Box sx={{ p: { xs: 3, sm: 4 } }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 4,
            }}
          >
            <Typography variant="h4" sx={{ fontWeight: 700, color: "#1e293b" }}>
              User Expiring
            </Typography>
            <Box sx={{ display: "flex", gap: 0.5 }}>
              <Tooltip title="Excel">
                <IconButton
                  size="small"
                  onClick={() => exportFile("xlsx")}
                  sx={{
                    transition: "all 0.2s ease-in-out",
                    "&:hover": {
                      transform: "scale(1.1) translateY(-2px)",
                      backgroundColor: "transparent",
                    },
                  }}
                >
                  <img src={Excel} alt="Excel" width={28} height={28} />
                </IconButton>
              </Tooltip>
              <Tooltip title="CSV">
                <IconButton
                  size="small"
                  onClick={() => exportFile("csv")}
                  sx={{
                    transition: "all 0.2s ease-in-out",
                    "&:hover": {
                      transform: "scale(1.1) translateY(-2px)",
                      backgroundColor: "transparent",
                    },
                  }}
                >
                  <img src={Csv} alt="CSV" width={28} height={28} />
                </IconButton>
              </Tooltip>
              <Tooltip title="PDF">
                <IconButton
                  size="small"
                  onClick={() => exportFile("pdf")}
                  sx={{
                    transition: "all 0.2s ease-in-out",
                    "&:hover": {
                      transform: "scale(1.1) translateY(-2px)",
                      backgroundColor: "transparent",
                    },
                  }}
                >
                  <PictureAsPdf sx={{ fontSize: 28, color: "#ef4444" }} />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>

          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons={false}
            sx={{
              mb: 4,
              minHeight: "40px",
              "& .MuiTabs-indicator": {
                display: "none",
              },
              "& .MuiTabs-flexContainer": {
                gap: "8px",
              },
            }}
          >
            {[
              { label: "Yesterday", count: yesterdayCount },
              { label: "Today active", count: todayCount },
              { label: "Tomorrow", count: tomorrowCount },
              { label: "Next 15 Days", count: next2DaysCount },
            ].map((tab, index) => (
              <Tab
                key={index}
                label={
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    {tab.label}
                    <Box
                      sx={{
                        px: 1,
                        py: 0.25,
                        borderRadius: "12px",
                        fontSize: "11px",
                        backgroundColor: tabValue === index ? "rgba(255,255,255,0.3)" : "#f1f5f9",
                        color: tabValue === index ? "#ffffff" : "#64748b",
                      }}
                    >
                      {tab.count}
                    </Box>
                  </Box>
                }
                sx={{
                  borderRadius: "30px",
                  minHeight: "40px",
                  px: 3,
                  textTransform: "none",
                  fontWeight: 600,
                  fontSize: "0.875rem",
                  color: "#64748b",
                  backgroundColor: "#f1f5f9",
                  transition: "all 0.2s",
                  "&.Mui-selected": {
                    backgroundColor: "#3b82f6",
                    color: "#ffffff",
                    boxShadow: "0 4px 12px rgba(59, 130, 246, 0.25)",
                  },
                }}
              />
            ))}
          </Tabs>

          {/* Tab Panels */}
          <Box sx={{ minHeight: 310 }}>
            {[
              {
                data: expiringYesterdays,
                paging: expiringYesterdayPaging,
                payload: expiringYesterdayPayload,
                setPayload: setExpiringYesterdayPayload,
              },
              {
                data: expiringTodays,
                paging: expiringTodayPaging,
                payload: expiringTodayPayload,
                setPayload: setExpiringTodayPayload,
              },
              {
                data: expiringTomorrow,
                paging: expiringTomorrowPaging,
                payload: expiringTomorrowPayload,
                setPayload: setExpiringTomorrowPayload,
              },
              {
                data: expiringNextTwoDays,
                paging: expiringNextTwoDayPaging,
                payload: expiringNextTwoDayPayload,
                setPayload: setExpiringNextTwoDayPayload,
              },
            ].map((panel, index) => (
              <TabPanel key={index} value={tabValue} index={index}>
                <Expiring
                  data={panel.data}
                  paging={panel.paging}
                  payload={panel.payload}
                  setPayload={panel.setPayload}
                />
              </TabPanel>
            ))}
          </Box>
        </Box>
      </Card>
    </Grid>
  );
}

export default UserExpiring;
